import { useMemo } from "react";

import { ModuleStatus, WorkspaceDb } from "src/clients/flow-api";
import { useWorkspaceContext } from "src/router/routerContextHooks";

export const isLegacyModuleEnabled = (
  modules: WorkspaceDb["modules"] | undefined,
  kind: string,
): boolean => {
  const mod = modules?.[kind as keyof typeof modules];
  if (!mod) return false;
  return (
    mod.status !== ModuleStatus.CREATE_IN_PROGRESS &&
    mod.status !== ModuleStatus.CREATE_FAILED
  );
};

export const useIsModuleEnabled = (kind: string): { isEnabled: boolean } => {
  const { legacyModules, modules } = useWorkspaceContext();

  const isEnabled = useMemo(() => {
    if (modules && modules.length > 0) {
      const mod = modules.find((m) => m.kind === kind);
      // We rely on the /v1/modules API only if it exists.
      // We will return the direct check result when the migration is complete.
      if (mod !== undefined && mod.spec !== null) {
        return true;
      }
    }
    return isLegacyModuleEnabled(legacyModules, kind);
  }, [legacyModules, modules, kind]);

  return { isEnabled };
};
